import React, { Component, Children } from "react";
import "./Modal.scss";
import { Button } from "semantic-ui-react";
import { CSSTransition } from "react-transition-group";

import { ReactComponent as CloseIcon } from "../../../assets/svg/close.svg";

class Modal extends Component {
    render() {
        return (
            <CSSTransition show="" timeout={200} classNames="slidedown" unmountOnExit={true} in={this.props.show}>
                <div ref={this.props.forwardedRef} className={`custom-modal-dimmer ${this.props.noSkipGTranslate ? "" : "skiptranslate"}`}>
                    <div className="custom-modal-backdrop">
                        <div className={`custom-modal ${this.props.className || ""}`}>
                            {Children.map(this.props.children, (child) => React.cloneElement(child, { onClose: this.props.onClose }))}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
    }
}

class Header extends Component {
    render() {
        return (
            <div className={`custom-modal-header skiptranslate ${this.props.className || ""}`}>
                {!this.props.hideCloseIcon && (
                    <div className="custom-modal-header-action-button">
                        <CloseIcon className="custom-modal-close-icon" onClick={(e) => this.props.onClose(e)} />
                    </div>
                )}
                {this.props.children && <div className={`custom-modal-header-text ${this.props.className}`}>{this.props.children}</div>}
            </div>
        );
    }
}

class Content extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div
                className={`custom-modal-content ${this.props.className || ""} ${this.props.noSkipGTranslate ? "" : "skiptranslate"}`}
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

class Actions extends Component {
    render() {
        return <div className={`custom-modal-actions skiptranslate ${this.props.className || ""}`}>{this.props.children}</div>;
    }
}

export class ActionButton extends Component {
    render() {
        return (
            <Button
                onClick={(e) => this.props.onClick(e)}
                disabled={this.props.disabled}
                className={`custom-modal-action-button skiptranslate ${this.props.className} ${this.props.filled ? "custom-modal-action-button-filled" : ""} ${
                    this.props.normal ? "custom-modal-action-button-normal" : ""
                }`}>
                {this.props.children}
            </Button>
        );
    }
}

export class ConfirmModal extends Modal {
    render() {
        return (
            <CSSTransition {...this.props} timeout={200} classNames="slidedown" unmountOnExit={true} in={this.props.show}>
                <div className="custom-modal-dimmer skiptranslate">
                    <div className="custom-modal-backdrop">
                        <div className={`custom-modal custom-modal-confirm ${this.props.className || ""}`} style={this.getModalStyles()}>
                            {React.Children.map(this.props.children, (child) => React.cloneElement(child, { onClose: this.props.onClose }))}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
    }
}

Modal.Header = Header;
Modal.Content = Content;
Modal.Actions = Actions;
Modal.ActionButton = ActionButton;
export default Modal;
